import  * as React from "react";
import { observer } from "mobx-react";
import { IPrintedLegendsProps } from "./IPrintedLegendsProps";
import { TagsList } from "Components";

@observer
export class PrintedLegends extends React.Component<IPrintedLegendsProps>{
    constructor(props: IPrintedLegendsProps) {
        super(props, undefined);
    }

    render() {
        let legendsGroupClass = this.props.measurementsData.length > 9 ? 'col-xs-6' : 'col-xs-12';
        return <div className="PrintedLegends">
            <p className="legends">Legends</p>
            <div className="individual-player-shots row">
                {this.props.individualPlayers.map((currentPlayer, i) => {
                    return this.props.measurementsData.map((group, j) => {
                        if (group.player?.id === currentPlayer.id && j < 18) {
                            return <div className={legendsGroupClass} key={currentPlayer.id+group.id}>
                                <div className="print-strokes-btn-wrapper">
                                    <div className="dot-wrapper"><span className="dot" style={{ backgroundColor: group.isSelected ? group.color : '#c1c1c1' }}></span> </div>
                                    <TagsList measurementGroup={group} unitPresentation={this.props.unitPresentation} className="printed-legends"/>
                                    <div className="shots-and-ball">
                                        <div className="ball-icon">
                                            <img src="Images/MultiGroupReport/single-shot-icon-without-border.png" alt="Ball icon" />
                                        </div>
                                        <div className="shots-number">
                                            <span className="shots-number-text">{group?.strokes?.length}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        return null;
                    })
                })}
            </div>
        </div>
    }
}
